
    import './styles.scoped.css';
    export default {
  "preference-icon--svg": "awsui_preference-icon--svg_d4xxm_1muyx_9",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_d4xxm_1muyx_15",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_d4xxm_1muyx_19",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_d4xxm_1muyx_22",
  "preference-icon--border": "awsui_preference-icon--border_d4xxm_1muyx_25",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_d4xxm_1muyx_29",
  "preference-icon--secondary": "awsui_preference-icon--secondary_d4xxm_1muyx_32",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_d4xxm_1muyx_35",
  "preference-icon--separator": "awsui_preference-icon--separator_d4xxm_1muyx_38",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_d4xxm_1muyx_41",
  "preference-icon-refresh--svg": "awsui_preference-icon-refresh--svg_d4xxm_1muyx_45",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_d4xxm_1muyx_51",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_d4xxm_1muyx_54",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_d4xxm_1muyx_57",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_d4xxm_1muyx_60",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_d4xxm_1muyx_63",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_d4xxm_1muyx_66",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_d4xxm_1muyx_70",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_d4xxm_1muyx_73",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_d4xxm_1muyx_76",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_d4xxm_1muyx_79",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_d4xxm_1muyx_82"
};
  